export default function timeAgo(dateString, options = {}) {
  if (!dateString) return '';
  const now = new Date();
  const past = new Date(dateString);

  const diffMs = now - past;

  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHours = Math.floor(diffMin / 60);
  const diffDays = Math.floor(diffHours / 24);

  const isLong = options.format === 'long';

  if (diffSec < 60) return isLong ? 'agora mesmo' : 'agora';
  if (diffMin < 60)
    return isLong ? `há ${diffMin} ${diffMin === 1 ? 'minuto' : 'minutos'}` : `${diffMin}min`;
  if (diffHours < 24)
    return isLong ? `há ${diffHours} ${diffHours === 1 ? 'hora' : 'horas'}` : `${diffHours}h`;
  if (diffDays === 1) return 'ontem';
  if (diffDays < 7) return isLong ? `há ${diffDays} dias` : `${diffDays}d`;
  return `há ${diffDays} dias`;
}
